import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "@/hooks/useAuth";
import { lazy, Suspense } from "react";

// Lazy load all page components for better code splitting
const Feed = lazy(() => import("./pages/Feed"));
const Auth = lazy(() => import("./pages/Auth"));
const Profile = lazy(() => import("./pages/Profile"));
const Assistantships = lazy(() => import("./pages/Assistantships"));
const Events = lazy(() => import("./pages/Events"));
const Admin = lazy(() => import("./pages/Admin"));
const AgriChat = lazy(() => import("./pages/AgriChat"));
const AgriLinkRequests = lazy(() => import("./pages/AgriLinkRequests"));
const SavedPosts = lazy(() => import("./pages/SavedPosts"));
const AboutAgriSociety = lazy(() => import("./pages/AboutAgriSociety"));
const PrivacyPolicy = lazy(() => import("./pages/PrivacyPolicy"));
const TermsAndGuidelines = lazy(() => import("./pages/TermsAndGuidelines"));
const BlockedAccounts = lazy(() => import("./pages/BlockedAccounts"));
const NotFound = lazy(() => import("./pages/NotFound"));

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <AuthProvider>
        <Toaster />
        <Sonner />
        <BrowserRouter>
          <Suspense fallback={<div className="flex items-center justify-center min-h-screen">Loading...</div>}>
            <Routes>
              <Route path="/" element={<Navigate to="/auth" replace />} />
              <Route path="/auth" element={<Auth />} />
              <Route path="/feed" element={<Feed />} />
              <Route path="/profile/:id" element={<Profile />} />
              <Route path="/agrichat" element={<AgriChat />} />
              <Route path="/assistantships" element={<Assistantships />} />
              <Route path="/events" element={<Events />} />
              <Route path="/admin" element={<Admin />} />
              <Route path="/agrilink-requests" element={<AgriLinkRequests />} />
              <Route path="/saved-posts" element={<SavedPosts />} />
              <Route path="/about" element={<AboutAgriSociety />} />
              <Route path="/privacy-policy" element={<PrivacyPolicy />} />
              <Route path="/terms" element={<TermsAndGuidelines />} />
              <Route path="/blocked-accounts" element={<BlockedAccounts />} />
              {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
              <Route path="*" element={<NotFound />} />
            </Routes>
          </Suspense>
        </BrowserRouter>
      </AuthProvider>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
